import MeasureListState from "../types/MeasureListState";

export default function createMeasureListState(): MeasureListState {
    return {
        measures: {},
    };
}